const S = {
  wrapper: { marginTop:'10px', padding:'40px', border:'3px solid #1a5c2a', fontFamily:"'Georgia', serif", color:'#0a1f0e', lineHeight:'1.7', background:'#f2faf4' },
  h1: { fontSize:'2rem', fontWeight:'700', borderBottom:'3px solid #2e8b47', paddingBottom:'8px', marginBottom:'24px', color:'#145a24' },
  h2: { fontSize:'1.3rem', fontWeight:'700', color:'#1e7a36', marginTop:'36px', marginBottom:'12px', borderLeft:'4px solid #2e8b47', paddingLeft:'10px' },
  p: { marginBottom:'12px', fontSize:'0.97rem' },
  infoBox: { background:'#e8f5ec', border:'2px solid #2e8b47', borderRadius:'6px', padding:'16px 20px', margin:'16px 0' },
  infoBoxTitle: { fontWeight:'700', fontFamily:"'Courier New', monospace", fontSize:'0.88rem', color:'#145a24', marginBottom:'8px' },
  infoBoxItem: { fontSize:'0.9rem', margin:'4px 0', paddingLeft:'12px', borderLeft:'2px solid #2e8b47' },
  table: { width:'100%', borderCollapse:'collapse', marginBottom:'20px', fontSize:'0.92rem' },
  th: { background:'#1e7a36', color:'#fff', padding:'10px 14px', textAlign:'left', fontWeight:'700', fontSize:'0.9rem' },
  tdE: { padding:'10px 14px', borderBottom:'1px solid #b6dfc0', verticalAlign:'top', background:'#edf7f0' },
  tdO: { padding:'10px 14px', borderBottom:'1px solid #b6dfc0', verticalAlign:'top', background:'#fff' },
  tdL: { fontWeight:'600', color:'#145a24', whiteSpace:'nowrap', width:'220px' },
  code: { fontFamily:"'Courier New', monospace", fontSize:'0.88rem', whiteSpace:'pre-wrap' },
  dWrap: { margin:'24px 0', background:'#f4fbf6', border:'1px solid #b6dfc0', borderRadius:'8px', padding:'20px' },
  dTitle: { fontWeight:'700', fontSize:'0.95rem', color:'#145a24', marginBottom:'12px', textAlign:'center', letterSpacing:'0.02em' },
  dCaption: { fontSize:'0.84rem', color:'#3a7a4a', textAlign:'center', marginTop:'10px', fontStyle:'italic' },
};

function InfoBox({ title, items }) {
  return (
    <div style={S.infoBox}>
      <div style={S.infoBoxTitle}>{title}</div>
      {items.map((item, i) => <div key={i} style={S.infoBoxItem}>{item}</div>)}
    </div>
  );
}

function Table2({ rows }) {
  return (
    <table style={S.table}>
      <thead><tr>
        <th style={{ ...S.th, width:'220px' }}>Concept</th>
        <th style={S.th}>Explanation / Details</th>
      </tr></thead>
      <tbody>
        {rows.map(([label, content], i) => (
          <tr key={i}>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.tdL }}>{label}</td>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.code }}>{content}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

// ── Diagram 1: Sandpaper / Coated Abrasive Anatomy ─────────────────
function DiagramSandpaperAnatomy() {
  const W = 960, H = 420;

  // Left label column x=0..210, cross-section x=215..620, right info panel x=635..955
  const labelMaxX = 208;
  const secL = 215;
  const secW = 405;
  const secCX = secL + secW / 2;

  const layers = [
    { label: 'Abrasive grains',    y: 60,  h: 52,  fill: '#c0392b', fg: '#fff',     desc: 'Al₂O₃, SiC, ZrO₂, ceramic' },
    { label: 'Size coat',          y: 112, h: 22,  fill: '#e07b00', fg: '#fff',     desc: 'Locks grains, controls spacing' },
    { label: 'Make coat',          y: 134, h: 22,  fill: '#bf6000', fg: '#fff',     desc: 'Primary bond to backing' },
    { label: 'Backing material',   y: 156, h: 36,  fill: '#78909c', fg: '#fff',     desc: 'Paper / cloth / film / fibre' },
  ];

  // Annotation dot positions on cross-section
  const annots = [
    { dotY: 60 + 26,  label: 'Abrasive grains (cutting edges)' },
    { dotY: 112 + 11, label: 'Size coat — locks grains in place' },
    { dotY: 134 + 11, label: 'Make coat — primary adhesive bond' },
    { dotY: 156 + 18, label: 'Backing — paper / cloth / film / fibre' },
  ];

  // Grain profile along top (irregular peaks)
  const grainSeeds = [0.2,0.7,1.3,2.1,2.8,3.5,4.1,4.9,5.6,6.2,6.9,7.6,8.2,8.9,9.5,10.2,10.8,11.5];
  const grainW = secW / grainSeeds.length;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Coated Abrasive (Sandpaper) — Layer Anatomy &amp; Construction</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <linearGradient id="backGrad" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#90a4ae"/>
            <stop offset="100%" stopColor="#546e7a"/>
          </linearGradient>
          <linearGradient id="makeGrad" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#bf7000"/>
            <stop offset="100%" stopColor="#8b4e00"/>
          </linearGradient>
          <linearGradient id="sizeGrad" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#f39c12"/>
            <stop offset="100%" stopColor="#d68910"/>
          </linearGradient>
          <pattern id="grainPat" x="0" y="0" width="22" height="52" patternUnits="userSpaceOnUse">
            <polygon points="11,2 20,48 2,48" fill="#c0392b" opacity="0.85"/>
            <polygon points="11,2 20,48 2,48" fill="none" stroke="#8b0000" strokeWidth="1"/>
          </pattern>
        </defs>

        {/* ── Left annotation labels ── */}
        {annots.map(({ dotY, label }, i) => (
          <g key={i}>
            <text x={labelMaxX} y={dotY + 4} textAnchor="end" fontSize="10" fill="#333">{label}</text>
            <line x1={labelMaxX + 4} y1={dotY} x2={secL - 4} y2={dotY}
                  stroke="#546e7a" strokeWidth="1" strokeDasharray="4,3"/>
            <circle cx={secL - 4} cy={dotY} r={3} fill="#546e7a"/>
          </g>
        ))}

        {/* ── Cross-section layers ── */}
        {/* Backing */}
        <rect x={secL} y={156} width={secW} height={36} fill="url(#backGrad)" stroke="#455a64" strokeWidth="1.5"/>
        <text x={secCX} y={179} textAnchor="middle" fontSize="11" fill="#fff" fontWeight="700">Backing (paper / cloth / film)</text>

        {/* Make coat */}
        <rect x={secL} y={134} width={secW} height={22} fill="url(#makeGrad)" stroke="#6d3200" strokeWidth="1"/>
        <text x={secCX} y={149} textAnchor="middle" fontSize="10" fill="#fff" fontWeight="700">Make Coat (primary bond)</text>

        {/* Size coat */}
        <rect x={secL} y={112} width={secW} height={22} fill="url(#sizeGrad)" stroke="#8b5500" strokeWidth="1"/>
        <text x={secCX} y={127} textAnchor="middle" fontSize="10" fill="#fff" fontWeight="700">Size Coat (secondary bond)</text>

        {/* Abrasive grain layer — individual grain triangles */}
        {grainSeeds.map((s, i) => {
          const gx = secL + i * grainW + 2;
          const gh = 28 + Math.sin(s * 2.3) * 14;
          const gw = 14 + Math.sin(s * 1.7) * 5;
          const topY = 112 - gh;
          return (
            <g key={i}>
              <polygon
                points={`${gx + gw/2},${topY} ${gx + gw},${112} ${gx},${112}`}
                fill="#c0392b" stroke="#8b0000" strokeWidth="0.8" opacity="0.9"/>
              {/* Sharp cutting edge glint */}
              <circle cx={gx + gw/2} cy={topY} r={1.5} fill="#fff" opacity="0.6"/>
            </g>
          );
        })}

        {/* Grain layer bracket label at top */}
        <text x={secCX} y={48} textAnchor="middle" fontSize="11" fill="#c0392b" fontWeight="700">Abrasive grains (cutting edges)</text>
        <line x1={secL} y1={54} x2={secL + secW} y2={54} stroke="#c0392b" strokeWidth="1" strokeDasharray="3,2"/>

        {/* Direction of cut arrow */}
        <defs>
          <marker id="cutArr" markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto">
            <polygon points="0 0, 7 4, 0 8" fill="#1e7a36"/>
          </marker>
        </defs>
        <line x1={secL} y1={32} x2={secL + secW} y2={32} stroke="#1e7a36" strokeWidth="2" markerEnd="url(#cutArr)"/>
        <text x={secCX} y={26} textAnchor="middle" fontSize="10" fill="#1e7a36" fontWeight="700">Cutting direction →</text>

        {/* Workpiece surface below */}
        <rect x={secL} y={192} width={secW} height={30} rx={2} fill="#a8d5b0" stroke="#2e8b47" strokeWidth="1.2" opacity="0.5"/>
        <text x={secCX} y={211} textAnchor="middle" fontSize="10" fill="#145a24">Workpiece surface</text>

        {/* Depth of cut dimension line */}
        <line x1={secL + secW + 16} y1={60} x2={secL + secW + 16} y2={112} stroke="#333" strokeWidth="1.2"/>
        <line x1={secL + secW + 10} y1={60}  x2={secL + secW + 22} y2={60}  stroke="#333" strokeWidth="1.2"/>
        <line x1={secL + secW + 10} y1={112} x2={secL + secW + 22} y2={112} stroke="#333" strokeWidth="1.2"/>
        <text x={secL + secW + 28} y={90} fontSize="9" fill="#333">grain</text>
        <text x={secL + secW + 28} y={102} fontSize="9" fill="#333">protrusion</text>

        {/* ── Right info panel ── */}
        <rect x={635} y={16} width={316} height={390} rx={5} fill="#fff" stroke="#b6dfc0" strokeWidth="1.2"/>
        <text x={793} y={36} textAnchor="middle" fontSize="13" fill="#145a24" fontWeight="700">Backing Types</text>

        {[
          { name:'A-weight paper',  prop1:'Lightest; flexible',         prop2:'Hand sanding, finishing',        col:'#e8f5ec' },
          { name:'C/D-weight paper',prop1:'Medium; semi-rigid',         prop2:'Orbital sanders, light stock',   col:'#fff' },
          { name:'E-weight paper',  prop1:'Heavy; rigid',               prop2:'Belt grinding, heavy stock',     col:'#e8f5ec' },
          { name:'J-weight cloth',  prop1:'Fine weave; very flexible',  prop2:'Contour sanding, metal',         col:'#fff' },
          { name:'X-weight cloth',  prop1:'Heavy weave; tough',         prop2:'Wide belt, drum, roll grinders', col:'#e8f5ec' },
          { name:'Polyester film',  prop1:'Dimensionally stable',       prop2:'Precision finishing, optics',    col:'#fff' },
        ].map(({ name, prop1, prop2, col }, i) => {
          const ry = 46 + i * 54;
          return (
            <g key={i}>
              <rect x={643} y={ry} width={300} height={48} rx={3} fill={col} stroke="#b6dfc0" strokeWidth="1"/>
              <text x={651} y={ry+16} fontSize="11" fill="#145a24" fontWeight="700">{name}</text>
              <text x={651} y={ry+30} fontSize="10" fill="#444">{prop1}</text>
              <text x={651} y={ry+43} fontSize="10" fill="#546e7a">{prop2}</text>
            </g>
          );
        })}
        <text x={793} y={382} textAnchor="middle" fontSize="10" fill="#546e7a" fontStyle="italic">CAMI / FEPA grit standards govern grade</text>
      </svg>
      <div style={S.dCaption}>A coated abrasive consists of abrasive grains bonded to a flexible backing with two adhesive layers. The make coat anchors grains to the backing; the size coat locks them in position and controls the active grain protrusion height. Backing weight determines stiffness — lighter weights conform to curves; heavier weights resist tearing under high belt tension.</div>
    </div>
  );
}

// ── Diagram 2: Abrasive Grain Cutting Mechanics ────────────────────
function DiagramGrainMechanics() {
  const W = 980, H = 420;

  // Three-column: label 0..205, three mechanism panels, right text 755..975
  const panels = [
    {
      title: '① Cutting',
      subtitle: 'Rake angle < critical θ',
      col: '#1e7a36',
      bg: '#e8f5ec',
      desc: 'Grain cuts cleanly into surface.\nChip curls up rake face.\nOccurs at higher depths of cut.',
      eff: 'High MRR\nGood for stock removal',
    },
    {
      title: '② Ploughing',
      subtitle: 'Grain pushes material aside',
      col: '#e07b00',
      bg: '#fff8e1',
      desc: 'Grain too blunt to cut cleanly.\nMaterial displaced laterally.\nForms ridges — no chip formed.',
      eff: 'Low MRR\nHigh subsurface damage',
    },
    {
      title: '③ Rubbing / Sliding',
      subtitle: 'Worn flat, no penetration',
      col: '#c0392b',
      bg: '#FEF0F0',
      desc: 'Grain tip fully worn flat.\nNo material removed — friction only.\nGenerates heat, glazing, burnishing.',
      eff: 'Zero MRR\nThermal damage risk',
    },
  ];

  const panelW = 168, panelGap = 10;
  const panelStartX = 210;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Abrasive Grain Interaction Modes — Cutting, Ploughing &amp; Rubbing</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <marker id="chipArr" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#1e7a36"/>
          </marker>
          <marker id="ploughArr" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#e07b00"/>
          </marker>
          <marker id="heatArr" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#c0392b"/>
          </marker>
        </defs>

        {/* Labels on left */}
        {[
          { y: 130, text: 'Cutting direction →' },
          { y: 190, text: 'Chip / deformation' },
          { y: 240, text: 'Workpiece material' },
          { y: 290, text: 'Grain tip geometry' },
        ].map(({ y, text }, i) => (
          <g key={i}>
            <text x={205} y={y} textAnchor="end" fontSize="10" fill="#333">{text}</text>
          </g>
        ))}

        {/* Three mechanism panels */}
        {panels.map(({ title, subtitle, col, bg, desc, eff }, pi) => {
          const px = panelStartX + pi * (panelW + panelGap);
          const py = 20;
          const ph = 360;

          // SVG micro-diagram in upper half of each panel
          const diagY = py + 60;  // y of workpiece surface
          const grainCX = px + panelW / 2;

          return (
            <g key={pi}>
              {/* Panel background */}
              <rect x={px} y={py} width={panelW} height={ph} rx={5}
                    fill={bg} stroke={col} strokeWidth="1.5"/>
              {/* Title */}
              <text x={px + panelW/2} y={py+18} textAnchor="middle" fontSize="12" fill={col} fontWeight="700">{title}</text>
              <text x={px + panelW/2} y={py+32} textAnchor="middle" fontSize="9" fill="#555">{subtitle}</text>

              {/* Workpiece block */}
              <rect x={px+8} y={diagY} width={panelW-16} height={50} rx={2} fill="#a8d5b0" stroke="#2e8b47" strokeWidth="1"/>
              <text x={grainCX} y={diagY+30} textAnchor="middle" fontSize="9" fill="#145a24">workpiece</text>

              {/* Grain — different shapes per mode */}
              {pi === 0 && (
                <g>
                  {/* Sharp cutting grain */}
                  <polygon points={`${grainCX},${diagY-36} ${grainCX+14},${diagY} ${grainCX-14},${diagY}`}
                           fill="#c0392b" stroke="#8b0000" strokeWidth="1"/>
                  {/* Cut chip curling off */}
                  <path d={`M ${grainCX+14},${diagY-14} Q ${grainCX+28},${diagY-28} ${grainCX+22},${diagY-44}`}
                        fill="none" stroke="#1e7a36" strokeWidth="2" markerEnd="url(#chipArr)"/>
                  <text x={grainCX+32} y={diagY-30} fontSize="9" fill="#1e7a36">chip</text>
                  {/* Depth of cut arrow */}
                  <line x1={grainCX-22} y1={diagY-10} x2={grainCX-22} y2={diagY}
                        stroke="#555" strokeWidth="1.2"/>
                  <text x={grainCX-28} y={diagY-4} textAnchor="end" fontSize="8" fill="#555">doc</text>
                </g>
              )}
              {pi === 1 && (
                <g>
                  {/* Slightly blunt grain */}
                  <polygon points={`${grainCX},${diagY-28} ${grainCX+16},${diagY} ${grainCX-16},${diagY}`}
                           fill="#e07b00" stroke="#bf6000" strokeWidth="1"/>
                  {/* Material piled up on sides */}
                  <path d={`M ${grainCX-16},${diagY} Q ${grainCX-28},${diagY-14} ${grainCX-36},${diagY-4}`}
                        fill="#c8e6c9" stroke="#2e8b47" strokeWidth="1.5"/>
                  <path d={`M ${grainCX+16},${diagY} Q ${grainCX+28},${diagY-14} ${grainCX+36},${diagY-4}`}
                        fill="#c8e6c9" stroke="#2e8b47" strokeWidth="1.5"/>
                  <text x={grainCX-40} y={diagY+10} textAnchor="middle" fontSize="8" fill="#2e8b47">ridge</text>
                  <text x={grainCX+40} y={diagY+10} textAnchor="middle" fontSize="8" fill="#2e8b47">ridge</text>
                </g>
              )}
              {pi === 2 && (
                <g>
                  {/* Flat/worn grain */}
                  <rect x={grainCX-14} y={diagY-20} width={28} height={20} rx={3}
                        fill="#c0392b" stroke="#8b0000" strokeWidth="1"/>
                  {/* Heat rays */}
                  {[-20,-8,4,16,28].map((dx, hi) => (
                    <line key={hi} x1={grainCX+dx} y1={diagY-24} x2={grainCX+dx-4} y2={diagY-38}
                          stroke="#c0392b" strokeWidth="1.5" strokeDasharray="2,2" opacity="0.8"/>
                  ))}
                  <text x={grainCX} y={diagY-42} textAnchor="middle" fontSize="9" fill="#c0392b">heat ↑</text>
                  {/* Flat worn face indicator */}
                  <text x={grainCX} y={diagY-6} textAnchor="middle" fontSize="8" fill="#fff">worn flat</text>
                </g>
              )}

              {/* Cutting direction arrow */}
              <line x1={px+12} y1={diagY-18} x2={px+panelW-12} y2={diagY-18}
                    stroke={col} strokeWidth="1.5" markerEnd={pi===0?"url(#chipArr)":pi===1?"url(#ploughArr)":"url(#heatArr)"}/>

              {/* Description text */}
              {desc.split('\n').map((line, li) => (
                <text key={li} x={px+8} y={py+160+li*18} fontSize="9.5" fill="#333">{line}</text>
              ))}

              {/* Effect summary box */}
              <rect x={px+6} y={py+ph-72} width={panelW-12} height={64} rx={3}
                    fill="#fff" stroke={col} strokeWidth="1"/>
              {eff.split('\n').map((line, li) => (
                <text key={li} x={px+10} y={py+ph-56+li*18} fontSize="10" fill={col} fontWeight={li===0?'700':'400'}>{line}</text>
              ))}
            </g>
          );
        })}

        {/* Right info panel: Grain geometry & properties */}
        <rect x={756} y={16} width={216} height={390} rx={5} fill="#fff" stroke="#b6dfc0" strokeWidth="1.2"/>
        <text x={864} y={36} textAnchor="middle" fontSize="13" fill="#145a24" fontWeight="700">Grain Properties</text>

        {[
          { prop:'Hardness',    val:'Must exceed workpiece\nhardness by ≥30%' },
          { prop:'Toughness',   val:'Resists fracture during\nimpact loading' },
          { prop:'Friability',  val:'Self-sharpens by micro-\nfracture under load' },
          { prop:'Thermal stab.',val:'Retains hardness at\nelevated temperatures' },
          { prop:'Shape',       val:'Angular = aggressive cut\nRounded = fine finish' },
        ].map(({ prop, val }, i) => {
          const ry = 46 + i * 64;
          return (
            <g key={i}>
              <rect x={764} y={ry} width={204} height={58} rx={3}
                    fill={i%2===0?'#edf7f0':'#fff'} stroke="#b6dfc0" strokeWidth="1"/>
              <text x={772} y={ry+17} fontSize="11" fill="#145a24" fontWeight="700">{prop}</text>
              {val.split('\n').map((line, li) => (
                <text key={li} x={772} y={ry+31+li*13} fontSize="10" fill="#444">{line}</text>
              ))}
            </g>
          );
        })}
        <text x={864} y={390} textAnchor="middle" fontSize="10" fill="#546e7a" fontStyle="italic">Grain shape affects surface Ra by 15–40%</text>
      </svg>
      <div style={S.dCaption}>Each abrasive grain acts as a micro-cutting tool. At sufficient depth of cut, the grain shears material to form a chip (cutting). At shallower penetration, material is plastically displaced sideways (ploughing). Completely worn grains only rub the surface, generating heat without material removal (rubbing/sliding). Grain friability — the tendency to micro-fracture and expose fresh sharp edges — is the key property governing the balance between these modes in service.</div>
    </div>
  );
}

// ── Diagram 3: Grit Size Scale & Surface Finish vs Material Removal ─
function DiagramGritScale() {
  const W = 960, H = 420;
  // Chart layout
  const cL = 130, cR = 590, cT = 60, cB = 320;
  const cW = cR - cL, cH = cB - cT;

  const grits = [
    { grit: 24,   camiMesh: 24,   fepa: 'P24',   raUm: 12.5,  mrr: 98,  use:'Heavy material removal, aggressive shaping' },
    { grit: 36,   camiMesh: 36,   fepa: 'P36',   raUm: 10.0,  mrr: 88,  use:'Rapid stock removal, weld dressing' },
    { grit: 60,   camiMesh: 60,   fepa: 'P60',   raUm: 6.3,   mrr: 72,  use:'General shaping, paint removal' },
    { grit: 80,   camiMesh: 80,   fepa: 'P80',   raUm: 4.0,   mrr: 58,  use:'Coarse finishing, prep for 120' },
    { grit: 120,  camiMesh: 120,  fepa: 'P120',  raUm: 2.5,   mrr: 42,  use:'Pre-finish, sealer coats' },
    { grit: 180,  camiMesh: 180,  fepa: 'P180',  raUm: 1.6,   mrr: 28,  use:'Fine finish prep, between coats' },
    { grit: 220,  camiMesh: 220,  fepa: 'P220',  raUm: 1.0,   mrr: 18,  use:'Final wood finish, light metal' },
    { grit: 320,  camiMesh: 320,  fepa: 'P320',  raUm: 0.63,  mrr: 10,  use:'Very fine finish, de-nibbing lacquer' },
    { grit: 400,  camiMesh: 400,  fepa: 'P400',  raUm: 0.40,  mrr: 6,   use:'Wet sanding paint, pre-polish' },
    { grit: 600,  camiMesh: 600,  fepa: 'P800',  raUm: 0.20,  mrr: 3,   use:'Polishing primer, micro-finish' },
    { grit: 1000, camiMesh: 1000, fepa: 'P1200', raUm: 0.10,  mrr: 1,   use:'Ultra-fine, pre-buffing' },
  ];

  const maxRa  = 13;
  const maxMrr = 100;
  const n      = grits.length;
  const barW   = (cW - (n - 1) * 4) / n;

  // Y scales
  const raY  = (v) => cB - (v / maxRa) * cH;
  const mrrY = (v) => cB - (v / maxMrr) * cH;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Abrasive Grit Size — Surface Roughness Ra (µm) &amp; Relative Material Removal Rate</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <marker id="gritArr" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#333"/>
          </marker>
        </defs>

        {/* Chart area */}
        <rect x={cL} y={cT} width={cW} height={cH} rx={3} fill="#f4fbf6" stroke="#b6dfc0"/>

        {/* Horizontal grid lines */}
        {[0,2,4,6,8,10,12].map(v => (
          <g key={v}>
            <line x1={cL} y1={raY(v)} x2={cR} y2={raY(v)} stroke="#b6dfc0" strokeWidth="1" strokeDasharray="4,3"/>
            <text x={cL-6} y={raY(v)+4} textAnchor="end" fontSize="9" fill="#555">{v}</text>
          </g>
        ))}

        {/* Bars — MRR (back, grey-green) and Ra (front, red) */}
        {grits.map(({ grit, raUm, mrr }, i) => {
          const bx = cL + i * (barW + 4);
          return (
            <g key={i}>
              {/* MRR bar (wider, behind) */}
              <rect x={bx} y={mrrY(mrr)} width={barW} height={cB - mrrY(mrr)}
                    fill="#a8d5b0" stroke="#2e8b47" strokeWidth="0.5" opacity="0.7" rx={2}/>
              {/* Ra bar (narrow, front) */}
              <rect x={bx + barW*0.25} y={raY(raUm)} width={barW*0.5} height={cB - raY(raUm)}
                    fill="#c0392b" opacity="0.82" rx={1}/>
              {/* Grit label */}
              <text x={bx + barW/2} y={cB + 14} textAnchor="middle" fontSize="8.5" fill="#145a24" fontWeight="700">{grit}</text>
            </g>
          );
        })}

        {/* Ra curve line */}
        <path d={grits.map(({ raUm }, i) => {
          const bx = cL + i * (barW + 4) + barW / 2;
          return (i === 0 ? 'M' : 'L') + bx.toFixed(1) + ',' + raY(raUm).toFixed(1);
        }).join(' ')} fill="none" stroke="#c0392b" strokeWidth="2" strokeDasharray="5,3"/>

        {/* MRR curve */}
        <path d={grits.map(({ mrr }, i) => {
          const bx = cL + i * (barW + 4) + barW / 2;
          return (i === 0 ? 'M' : 'L') + bx.toFixed(1) + ',' + mrrY(mrr).toFixed(1);
        }).join(' ')} fill="none" stroke="#2e8b47" strokeWidth="2" strokeDasharray="5,3"/>

        {/* Axes */}
        <line x1={cL} y1={cB} x2={cR + 10} y2={cB} stroke="#333" strokeWidth="1.5" markerEnd="url(#gritArr)"/>
        <line x1={cL} y1={cB} x2={cL} y2={cT - 10} stroke="#333" strokeWidth="1.5" markerEnd="url(#gritArr)"/>

        {/* Axis labels */}
        <text x={cL + cW/2} y={cB + 28} textAnchor="middle" fontSize="12" fill="#333">CAMI Grit Number (coarse → fine)</text>
        <text x={cL - 52} y={cT + cH/2} textAnchor="middle" fontSize="11" fill="#333"
              transform={`rotate(-90 ${cL-52} ${cT+cH/2})`}>Ra (µm) / MRR (relative)</text>

        {/* Legend — bottom-left of chart, inside cL area */}
        <rect x={cL + 4} y={cB - 38} width={12} height={10} fill="#c0392b" opacity="0.85"/>
        <text x={cL + 20} y={cB - 30} fontSize="10" fill="#333" fontWeight="700">Ra — surface roughness (µm)</text>
        <rect x={cL + 4} y={cB - 22} width={12} height={10} fill="#a8d5b0" opacity="0.9" stroke="#2e8b47" strokeWidth="0.5"/>
        <text x={cL + 20} y={cB - 14} fontSize="10" fill="#333" fontWeight="700">MRR — material removal rate (relative)</text>

        {/* Zone annotations — top band inside chart */}
        <rect x={cL}           y={cT}    width={cW * 0.28} height={20} rx={2} fill="#c0392b" opacity="0.08"/>
        <text x={cL + cW*0.14} y={cT+14} textAnchor="middle" fontSize="8.5" fill="#c0392b" fontWeight="700">COARSE</text>
        <rect x={cL + cW*0.28} y={cT}    width={cW * 0.36} height={20} rx={2} fill="#e07b00" opacity="0.08"/>
        <text x={cL + cW*0.46} y={cT+14} textAnchor="middle" fontSize="8.5" fill="#e07b00" fontWeight="700">MEDIUM</text>
        <rect x={cL + cW*0.64} y={cT}    width={cW * 0.36} height={20} rx={2} fill="#1e7a36" opacity="0.08"/>
        <text x={cL + cW*0.82} y={cT+14} textAnchor="middle" fontSize="8.5" fill="#1e7a36" fontWeight="700">FINE</text>

        {/* Right info panel */}
        <rect x={608} y={16} width={344} height={cH + cT - 30} rx={5} fill="#fff" stroke="#b6dfc0" strokeWidth="1.2"/>
        <text x={780} y={36} textAnchor="middle" fontSize="13" fill="#145a24" fontWeight="700">Grit Standards</text>

        {[
          { std:'CAMI (USA)',    body:'Coated Abrasive Manufacturers\nInstitute — traditional US system' },
          { std:'FEPA / ISO',   body:'European standard; P-grading.\nP80 ≈ CAMI 80; diverges at fine grits' },
          { std:'Micro-grading',body:'JIS (Japan): #1000–#30000\nUsed for ultra-fine polishing' },
          { std:'Grit size (d)',body:'Mean grain diameter in µm.\nCAMI 80 → d ≈ 200 µm' },
        ].map(({ std, body }, i) => {
          const ry = 46 + i * 68;
          return (
            <g key={i}>
              <rect x={644} y={ry} width={300} height={60} rx={3}
                    fill={i%2===0?'#edf7f0':'#fff'} stroke="#b6dfc0" strokeWidth="1"/>
              <text x={652} y={ry+18} fontSize="11" fill="#145a24" fontWeight="700">{std}</text>
              {body.split('\n').map((line, li) => (
                <text key={li} x={652} y={ry+32+li*14} fontSize="10" fill="#444">{line}</text>
              ))}
            </g>
          );
        })}
        <text x={794} y={cH + cT - 18} textAnchor="middle" fontSize="9.5" fill="#546e7a" fontStyle="italic">
          Grit size d ≈ 15,000 / (CAMI number) µm
        </text>
      </svg>
      <div style={S.dCaption}>As grit number increases, individual grain diameter decreases — finer grits produce lower Ra but also remove material more slowly. The relationship is non-linear; halving the grit number roughly doubles grain diameter but quadruples cross-sectional area. Successive grit progression (never skip more than one step) minimises total sanding time by removing the scratches of the previous grit efficiently.</div>
    </div>
  );
}

// ── Diagram 4: Belt Sanding / Wide-Belt Machine Anatomy ─────────────
function DiagramBeltSander() {
  const W = 960, H = 450;
  // Layout: labels left 0..210, machine 215..620, right panel 635..955
  const labelMaxX = 208;
  const mL = 218;

  // Annotation rows (label y, dot location on machine)
  const annots = [
    { dotX: mL + 180, dotY: 62,  label: 'Contact / drive drum (rubber-coated)' },
    { dotX: mL + 320, dotY: 84,  label: 'Tension / idler drum' },
    { dotX: mL + 250, dotY: 152, label: 'Abrasive belt (coated, spliced endless)' },
    { dotX: mL + 100, dotY: 228, label: 'Pressure platen / contact shoe' },
    { dotX: mL + 250, dotY: 290, label: 'Workpiece (conveyed through nip)' },
    { dotX: mL + 250, dotY: 340, label: 'Feed conveyor (rubber rollers)' },
  ];

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Wide-Belt Sander / Belt Grinding Machine — Anatomy &amp; Operation</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <linearGradient id="drumGrad" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#b0bec5"/>
            <stop offset="100%" stopColor="#607d8b"/>
          </linearGradient>
          <linearGradient id="beltGrad" x1="0" y1="0" x2="1" y2="0">
            <stop offset="0%" stopColor="#c0392b"/>
            <stop offset="100%" stopColor="#922b21"/>
          </linearGradient>
          <linearGradient id="convGrad" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#a5d6a7"/>
            <stop offset="100%" stopColor="#388e3c"/>
          </linearGradient>
          <marker id="beltArr" markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto">
            <polygon points="0 0, 7 4, 0 8" fill="#c0392b"/>
          </marker>
          <marker id="feedArr" markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto">
            <polygon points="0 0, 7 4, 0 8" fill="#2e8b47"/>
          </marker>
        </defs>

        {/* ── Left annotation labels ── */}
        {annots.map(({ dotX, dotY, label }, i) => (
          <g key={i}>
            <text x={labelMaxX} y={dotY + 4} textAnchor="end" fontSize="10" fill="#333">{label}</text>
            <line x1={labelMaxX + 4} y1={dotY} x2={dotX - 5} y2={dotY}
                  stroke="#546e7a" strokeWidth="1" strokeDasharray="4,3"/>
            <circle cx={dotX} cy={dotY} r={3} fill="#546e7a"/>
          </g>
        ))}

        {/* ── Machine drawing ── */}

        {/* Drive drum (left) */}
        <ellipse cx={mL + 180} cy={100} rx={40} ry={40} fill="url(#drumGrad)" stroke="#455a64" strokeWidth="2"/>
        <ellipse cx={mL + 180} cy={100} rx={30} ry={30} fill="#78909c" opacity="0.4"/>
        <text x={mL + 180} y={104} textAnchor="middle" fontSize="9" fill="#fff" fontWeight="700">DRIVE</text>
        {/* Drive drum rotation arrows */}
        <path d={`M ${mL+152},${78} A 30 30 0 0 1 ${mL+208},${78}`}
              fill="none" stroke="#c0392b" strokeWidth="1.5" markerEnd="url(#beltArr)"/>

        {/* Tension drum (right) */}
        <ellipse cx={mL + 320} cy={100} rx={36} ry={36} fill="url(#drumGrad)" stroke="#455a64" strokeWidth="2"/>
        <ellipse cx={mL + 320} cy={100} rx={26} ry={26} fill="#78909c" opacity="0.4"/>
        <text x={mL + 320} y={104} textAnchor="middle" fontSize="9" fill="#fff" fontWeight="700">IDLER</text>

        {/* Belt — top span */}
        <rect x={mL + 180} y={62} width={140} height={16} rx={2} fill="url(#beltGrad)" stroke="#8b0000" strokeWidth="1"/>
        {/* Belt arrow on top span */}
        <line x1={mL+210} y1={70} x2={mL+295} y2={70} stroke="#fff" strokeWidth="1.5" markerEnd="url(#beltArr)" opacity="0.7"/>

        {/* Belt — bottom span (active cutting zone) */}
        <rect x={mL + 68} y={196} width={296} height={16} rx={2} fill="url(#beltGrad)" stroke="#8b0000" strokeWidth="1"/>
        {/* Belt direction arrow on bottom span (reversed) */}
        <line x1={mL+310} y1={204} x2={mL+220} y2={204} stroke="#fff" strokeWidth="1.5" markerEnd="url(#beltArr)" opacity="0.7"/>
        <text x={mL+250} y={188} textAnchor="middle" fontSize="9" fill="#c0392b" fontWeight="700">← Belt travel direction</text>

        {/* Left belt wrap (drive side) */}
        <path d={`M ${mL+180},${62} A 38,38 0 0 0 ${mL+180},${212}`}
              fill="none" stroke="#922b21" strokeWidth="16" strokeLinecap="round" opacity="0.85"/>

        {/* Right belt wrap (idler side) */}
        <path d={`M ${mL+320},${62} A 34,34 0 0 1 ${mL+320},${212}`}
              fill="none" stroke="#922b21" strokeWidth="14" strokeLinecap="round" opacity="0.85"/>

        {/* Pressure platen / contact shoe */}
        <rect x={mL + 68} y={212} width={130} height={28} rx={3} fill="#78909c" stroke="#546e7a" strokeWidth="1.5"/>
        <text x={mL + 133} y={230} textAnchor="middle" fontSize="9" fill="#fff" fontWeight="700">Pressure Platen</text>
        {/* Spring / adjustment screws */}
        {[90, 120, 150, 180].map(dx => (
          <g key={dx}>
            <line x1={mL + dx} y1={212} x2={mL + dx} y2={196} stroke="#90a4ae" strokeWidth="2"/>
            <circle cx={mL + dx} cy={190} r={4} fill="#b0bec5" stroke="#78909c" strokeWidth="1"/>
          </g>
        ))}
        <text x={mL + 133} y={178} textAnchor="middle" fontSize="8" fill="#546e7a">spring pressure adjustment</text>

        {/* Workpiece */}
        <rect x={mL + 100} y={270} width={300} height={38} rx={3} fill="#e07b00" stroke="#bf6000" strokeWidth="1.5"/>
        <text x={mL + 250} y={293} textAnchor="middle" fontSize="11" fill="#fff" fontWeight="700">Workpiece</text>

        {/* Feed direction arrow */}
        <line x1={mL + 68} y1={320} x2={mL + 100} y2={320} stroke="#2e8b47" strokeWidth="2.5" markerEnd="url(#feedArr)"/>
        <text x={mL + 52} y={324} textAnchor="end" fontSize="9" fill="#2e8b47" fontWeight="700">feed →</text>

        {/* Conveyor */}
        <rect x={mL + 68} y={326} width={300} height={22} rx={3} fill="url(#convGrad)" stroke="#2e7d32" strokeWidth="1.2"/>
        <text x={mL + 250} y={341} textAnchor="middle" fontSize="9" fill="#fff">Conveyor / Feed table</text>

        {/* Nip zone highlight */}
        <rect x={mL + 100} y={212} width={45} height={58} rx={2} fill="#1e7a36" opacity="0.12" stroke="#1e7a36" strokeWidth="1" strokeDasharray="3,2"/>
        <text x={mL + 122} y={260} textAnchor="middle" fontSize="8" fill="#1e7a36" fontWeight="700">NIP</text>
        <text x={mL + 122} y={270} textAnchor="middle" fontSize="8" fill="#1e7a36" fontWeight="700">ZONE</text>

        {/* Dust collection port */}
        <rect x={mL + 310} y={218} width={36} height={24} rx={3} fill="#546e7a" stroke="#37474f" strokeWidth="1"/>
        <text x={mL + 328} y={233} textAnchor="middle" fontSize="8" fill="#fff">Dust</text>
        <text x={mL + 312} y={252} fontSize="8" fill="#546e7a">↑ to collector</text>

        {/* ── Right info panel ── */}
        <rect x={636} y={16} width={316} height={410} rx={5} fill="#fff" stroke="#b6dfc0" strokeWidth="1.2"/>
        <text x={794} y={36} textAnchor="middle" fontSize="13" fill="#145a24" fontWeight="700">Belt Sander Types</text>

        {[
          { name:'Wide-belt sander',   l1:'Belt width 300–1600 mm',    l2:'Panel, furniture, MDF, composites' },
          { name:'Drum / shell sander',l1:'Rotating drum with sleeve',  l2:'Small parts, curved profiles' },
          { name:'Stroke / file sander',l1:'Narrow belt, straight shoe', l2:'Welds, pipes, sheet metal' },
          { name:'Bench belt grinder', l1:'90°/vertical table, manual', l2:'Tool sharpening, small parts' },
          { name:'Robotic abrasive cell',l1:'6-axis arm + force control', l2:'Aerospace alloys, complex forms' },
        ].map(({ name, l1, l2 }, i) => {
          const ry = 46 + i * 68;
          return (
            <g key={i}>
              <rect x={644} y={ry} width={300} height={60} rx={3}
                    fill={i%2===0?'#edf7f0':'#fff'} stroke="#b6dfc0" strokeWidth="1"/>
              <text x={652} y={ry+18} fontSize="11" fill="#145a24" fontWeight="700">{name}</text>
              <text x={652} y={ry+33} fontSize="10" fill="#444">{l1}</text>
              <text x={652} y={ry+48} fontSize="10" fill="#546e7a">{l2}</text>
            </g>
          );
        })}

        {/* Contact pressure formula */}
        <rect x={644} y={396} width={300} height={26} rx={3} fill="#e8f5ec" stroke="#2e8b47" strokeWidth="1"/>
        <text x={652} y={413} fontSize="10" fill="#145a24" fontWeight="700">Contact pressure P = F / (belt width × contact length)</text>
      </svg>
      <div style={S.dCaption}>In a wide-belt sander the abrasive belt wraps around a drive drum (rubber-faced for grip and vibration absorption) and an idler tension drum. A pressure platen or contact roll presses the active belt span against the workpiece passing on the conveyor. Contact pressure, belt speed, feed rate, and grit determine material removal rate and surface finish. Dust extraction is critical for fire safety and operator health.</div>
    </div>
  );
}

// ── Diagram 5: Surface Finish vs Process Chart ──────────────────────
function DiagramFinishComparison() {
  const W = 960, H = 400;
  const cL = 240, cR = 760, cT = 36, cB = 360;
  const cW = cR - cL;

  // Ra range [min, max] in µm per process
  const processes = [
    { name:'Hand sanding P24–60',    rMin:6.3,  rMax:16.0, col:'#c0392b', cat:'Coarse' },
    { name:'Hand sanding P80–150',   rMin:1.6,  rMax:6.3,  col:'#e07b00', cat:'Medium' },
    { name:'Hand sanding P180–400',  rMin:0.2,  rMax:1.6,  col:'#f0c040', cat:'Fine' },
    { name:'Wide-belt (coarse belt)',rMin:1.6,  rMax:6.3,  col:'#2e8b47', cat:'Machine' },
    { name:'Wide-belt (fine belt)',  rMin:0.4,  rMax:1.6,  col:'#52b96a', cat:'Machine' },
    { name:'Drum sander (wood)',     rMin:0.8,  rMax:3.2,  col:'#1a5c2a', cat:'Machine' },
    { name:'Stroke sander (metal)',  rMin:0.4,  rMax:2.5,  col:'#78909c', cat:'Machine' },
    { name:'Random orbit (orbital)', rMin:0.4,  rMax:2.0,  col:'#a8d5b0', cat:'Machine' },
    { name:'Wet sanding P600–1200', rMin:0.05, rMax:0.4,  col:'#1565c0', cat:'Fine' },
    { name:'Superfinishing / lapping',rMin:0.01,rMax:0.10, col:'#9c27b0', cat:'Ultra-fine' },
  ];

  // Log scale Ra: 0.01 → 20 µm
  const logMin = Math.log10(0.008), logMax = Math.log10(22);
  const rx = v => cL + ((Math.log10(v) - logMin) / (logMax - logMin)) * cW;
  const rowH = (cB - cT) / processes.length;

  const tickVals = [0.01, 0.05, 0.1, 0.2, 0.5, 1, 2, 5, 10, 20];

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Surface Roughness Ra (µm) by Sanding Process — Logarithmic Scale</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <marker id="fcArr" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#333"/>
          </marker>
        </defs>

        {/* Chart background */}
        <rect x={cL} y={cT} width={cW} height={cB - cT} rx={3} fill="#f4fbf6" stroke="#b6dfc0"/>

        {/* Vertical grid at tick values */}
        {tickVals.map(v => (
          <g key={v}>
            <line x1={rx(v)} y1={cT} x2={rx(v)} y2={cB} stroke="#b6dfc0" strokeWidth="1" strokeDasharray="3,3"/>
            <text x={rx(v)} y={cB + 14} textAnchor="middle" fontSize="9" fill="#555">{v}</text>
          </g>
        ))}

        {/* Category zone bands (subtle) */}
        {[
          { x1:rx(0.008), x2:rx(0.12),  fill:'#1565c0', label:'Mirror / lapped' },
          { x1:rx(0.12),  x2:rx(0.8),   fill:'#1e7a36', label:'Fine finish' },
          { x1:rx(0.8),   x2:rx(3.2),   fill:'#e07b00', label:'Machined / medium' },
          { x1:rx(3.2),   x2:rx(22),    fill:'#c0392b', label:'Coarse / rough' },
        ].map(({ x1, x2, fill, label }) => (
          <g key={label}>
            <rect x={x1} y={cT} width={x2-x1} height={cB - cT} fill={fill} opacity="0.05"/>
            <text x={(x1+x2)/2} y={cT + 12} textAnchor="middle" fontSize="8" fill={fill} fontWeight="700" opacity="0.8">{label}</text>
          </g>
        ))}

        {/* Process bars */}
        {processes.map(({ name, rMin, rMax, col }, i) => {
          const y = cT + i * rowH;
          const bh = rowH - 4;
          const by = y + 2;
          return (
            <g key={i}>
              <rect x={0} y={y} width={W} height={rowH - 1} fill={i%2===0?'#f4fbf6':'#fff'} opacity="0.5"/>
              {/* Name label — right-aligned in left column */}
              <text x={cL - 8} y={by + bh/2 + 4} textAnchor="end" fontSize="10" fill="#0a1f0e">{name}</text>
              {/* Range bar */}
              <rect x={rx(rMin)} y={by + 2} width={rx(rMax) - rx(rMin)} height={bh - 4}
                    rx={3} fill={col} opacity="0.80"/>
              {/* Min / max labels */}
              <text x={rx(rMin) - 3} y={by + bh/2 + 4} textAnchor="end" fontSize="8.5" fill={col} fontWeight="700">{rMin}</text>
              <text x={rx(rMax) + 3} y={by + bh/2 + 4} fontSize="8.5" fill={col} fontWeight="700">{rMax}</text>
            </g>
          );
        })}

        {/* X axis */}
        <line x1={cL} y1={cB} x2={cR + 8} y2={cB} stroke="#333" strokeWidth="1.5" markerEnd="url(#fcArr)"/>
        <text x={cL + cW/2} y={cB + 28} textAnchor="middle" fontSize="12" fill="#333">Ra (µm) — log scale</text>

        {/* Right panel: roughness grade table */}
        <rect x={772} y={cT} width={180} height={cB - cT} rx={5} fill="#fff" stroke="#b6dfc0" strokeWidth="1.2"/>
        <text x={862} y={cT + 18} textAnchor="middle" fontSize="11" fill="#145a24" fontWeight="700">ISO Grade N</text>
        {[
          { n:'N12', ra:'50' }, { n:'N11', ra:'25' }, { n:'N10', ra:'12.5' },
          { n:'N9',  ra:'6.3' }, { n:'N8',  ra:'3.2' }, { n:'N7',  ra:'1.6' },
          { n:'N6',  ra:'0.8' }, { n:'N5',  ra:'0.4' }, { n:'N4',  ra:'0.2' },
          { n:'N3',  ra:'0.1' }, { n:'N2',  ra:'0.05'}, { n:'N1',  ra:'0.025'},
        ].map(({ n, ra }, i) => {
          const gy = cT + 24 + i * 26;
          return (
            <g key={n}>
              <rect x={780} y={gy} width={164} height={24} rx={2}
                    fill={i%2===0?'#edf7f0':'#fff'} stroke="#b6dfc0" strokeWidth="0.8"/>
              <text x={800}  y={gy+16} fontSize="10" fill="#145a24" fontWeight="700">{n}</text>
              <text x={930}  y={gy+16} textAnchor="end" fontSize="10" fill="#c0392b" fontFamily="'Courier New',monospace">{ra} µm</text>
            </g>
          );
        })}
      </svg>
      <div style={S.dCaption}>Surface roughness spans six orders of magnitude across sanding processes. Coarse hand sanding with P24–60 produces Ra 6–16 µm (ISO N10–N12); fine wet sanding with P1200 approaches Ra 0.05–0.2 µm (ISO N2–N4); lapping and superfinishing can reach below Ra 0.01 µm. The chart shows typical achievable ranges — actual Ra depends on material hardness, belt pressure, speed, and backing conformability.</div>
    </div>
  );
}

// ── Diagram 6: Sanding Parameters & Heat Generation ─────────────────
function DiagramHeatAndParameters() {
  const W = 980, H = 400;

  // Left: parameter interaction diagram (force, speed, feed → Ra, MRR, heat)
  // Right: temperature vs belt speed chart

  const cL = 530, cR = 950, cT = 46, cB = 360;
  const cW = cR - cL, cH = cB - cT;

  // Belt speed 5–50 m/s → temperature (simplified linear + exponential blend)
  const speeds = Array.from({ length: 30 }, (_, i) => 5 + i * 1.5);
  const temp   = speeds.map(v => 60 + 2.8 * v + 0.12 * v * v);
  const maxT   = Math.max(...temp);
  const sx = v => cL + ((v - 5) / 45) * cW;
  const ty = v => cB - ((v - 50) / (maxT - 50)) * cH;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Sanding Process Parameters — Interactions &amp; Thermal Effects</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <marker id="paramArr" markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto">
            <polygon points="0 0, 7 4, 0 8" fill="#1e7a36"/>
          </marker>
          <marker id="tempArr" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#333"/>
          </marker>
        </defs>

        {/* ── LEFT: Parameter influence diagram ── */}
        {/* Input parameters */}
        {[
          { x:60, y:70,  label:'Belt speed (m/s)',   desc:'↑ speed → ↑ temp, ↓ Ra' },
          { x:60, y:150, label:'Contact pressure (N/mm²)', desc:'↑ pressure → ↑ MRR, wear' },
          { x:60, y:230, label:'Feed rate (m/min)',  desc:'↑ feed → ↑ MRR, coarser Ra' },
          { x:60, y:310, label:'Grit size',          desc:'Finer → lower Ra, lower MRR' },
        ].map(({ x, y, label, desc }, i) => (
          <g key={i}>
            <rect x={x} y={y - 18} width={176} height={40} rx={4}
                  fill="#e8f5ec" stroke="#2e8b47" strokeWidth="1.2"/>
            <text x={x + 8} y={y} fontSize="10" fill="#145a24" fontWeight="700">{label}</text>
            <text x={x + 8} y={y + 14} fontSize="9" fill="#546e7a">{desc}</text>
            {/* Arrow to process box */}
            <line x1={x + 176} y1={y + 2} x2={258} y2={190}
                  stroke="#2e8b47" strokeWidth="1.2" strokeDasharray="4,3" markerEnd="url(#paramArr)" opacity="0.7"/>
          </g>
        ))}

        {/* Central process box */}
        <rect x={248} y={162} width={114} height={56} rx={6} fill="#1e7a36" stroke="#145a24" strokeWidth="2"/>
        <text x={305} y={187} textAnchor="middle" fontSize="11" fill="#fff" fontWeight="700">SANDING</text>
        <text x={305} y={203} textAnchor="middle" fontSize="11" fill="#fff" fontWeight="700">PROCESS</text>

        {/* Output arrows */}
        {[
          { x:370, y:72,  label:'Surface Roughness Ra', col:'#c0392b', note:'Decreases with finer grit,\nhigher speed' },
          { x:370, y:156, label:'Material Removal Rate', col:'#1e7a36', note:'Increases with pressure,\ncoarser grit, lower speed' },
          { x:370, y:240, label:'Heat Generation',       col:'#e07b00', note:'Increases rapidly with speed\n— thermal damage risk' },
          { x:370, y:314, label:'Belt/Tool Wear',        col:'#78909c', note:'Higher pressure accelerates\ngrain pullout and loading' },
        ].map(({ x, y, label, col, note }, i) => (
          <g key={i}>
            <line x1={362} y1={190} x2={x - 4} y2={y + 12}
                  stroke={col} strokeWidth="1.5" markerEnd="url(#paramArr)" opacity="0.8"/>
            <rect x={x} y={y} width={148} height={44} rx={4}
                  fill="#fff" stroke={col} strokeWidth="1.5"/>
            <text x={x + 8} y={y + 16} fontSize="10" fill={col} fontWeight="700">{label}</text>
            {note.split('\n').map((line, li) => (
              <text key={li} x={x + 8} y={y + 28 + li * 12} fontSize="9" fill="#555">{line}</text>
            ))}
          </g>
        ))}

        {/* ── RIGHT: Temperature vs belt speed chart ── */}
        <rect x={cL} y={cT} width={cW} height={cH} rx={3} fill="#f4fbf6" stroke="#b6dfc0"/>

        {/* Grid */}
        {[100,200,300,400].map(t => (
          <g key={t}>
            <line x1={cL} y1={ty(t)} x2={cR} y2={ty(t)} stroke="#b6dfc0" strokeWidth="1" strokeDasharray="4,3"/>
            <text x={cL - 4} y={ty(t) + 4} textAnchor="end" fontSize="9" fill="#555">{t}</text>
          </g>
        ))}
        {[10,20,30,40,50].map(v => (
          <line key={v} x1={sx(v)} y1={cT} x2={sx(v)} y2={cB} stroke="#b6dfc0" strokeWidth="1" strokeDasharray="4,3"/>
        ))}

        {/* Temperature curve */}
        <path d={speeds.map((v, i) => (i === 0 ? 'M' : 'L') + sx(v).toFixed(1) + ',' + ty(temp[i]).toFixed(1)).join(' ')}
              fill="none" stroke="#c0392b" strokeWidth="2.5"/>

        {/* Damage threshold zone — from top of chart down to threshold line */}
        <rect x={cL} y={cT} width={cW} height={Math.max(0, ty(250) - cT)}
              fill="#c0392b" opacity="0.08"/>
        <line x1={cL} y1={ty(250)} x2={cR} y2={ty(250)} stroke="#c0392b" strokeWidth="1.5" strokeDasharray="6,3"/>
        <text x={cR - 4} y={ty(250) - 4} textAnchor="end" fontSize="9" fill="#c0392b" fontWeight="700">Thermal damage threshold (~250°C)</text>

        {/* Optimal zone */}
        <rect x={cL} y={ty(150)} width={cW} height={ty(250) - ty(150)}
              fill="#1e7a36" opacity="0.06"/>
        <text x={cL + cW/2} y={ty(200)} textAnchor="middle" fontSize="9" fill="#1e7a36" fontWeight="700">Optimal operating zone</text>

        {/* Axes */}
        <line x1={cL} y1={cB} x2={cR + 8} y2={cB} stroke="#333" strokeWidth="1.5" markerEnd="url(#tempArr)"/>
        <line x1={cL} y1={cB} x2={cL} y2={cT - 8} stroke="#333" strokeWidth="1.5" markerEnd="url(#tempArr)"/>
        {[10,20,30,40,50].map(v => (
          <text key={v} x={sx(v)} y={cB + 14} textAnchor="middle" fontSize="9" fill="#555">{v}</text>
        ))}
        <text x={cL + cW/2} y={cB + 28} textAnchor="middle" fontSize="11" fill="#333">Belt speed (m/s)</text>
        <text x={cL - 36} y={cT + cH/2} textAnchor="middle" fontSize="11" fill="#333"
              transform={`rotate(-90 ${cL-36} ${cT+cH/2})`}>Interface temp (°C)</text>
        <text x={cL + cW/2} y={cT - 10} textAnchor="middle" fontSize="11" fill="#145a24" fontWeight="700">
          Grain–workpiece interface temperature vs belt speed
        </text>
      </svg>
      <div style={S.dCaption}>Sanding process outputs — Ra, MRR, temperature, and tool wear — are coupled functions of the four main input variables. Temperature rises super-linearly with belt speed; above ~250°C, thermal damage occurs (resin burn, workpiece scorching, grain loading). Optimising typically means maximising MRR within the thermal damage threshold, using flood coolant or reduced belt speed for heat-sensitive materials like aluminium alloys and thermoplastics.</div>
    </div>
  );
}

// ── Diagram 7: Abrasive Materials Comparison ──────────────────────
function DiagramAbrasiveMaterials() {
  const W = 960, H = 360;
  const materials = [
    { name:'Aluminium Oxide\n(Al₂O₃)', hardness:'~2000 HV', tough:'High', friab:'Low–Med', temp:'~600°C', bestFor:'Steel, iron, wood, general-purpose', col:'#8b5cf6' },
    { name:'Silicon Carbide\n(SiC)',    hardness:'~2500 HV', tough:'Low',  friab:'High',    temp:'~700°C', bestFor:'Non-ferrous, glass, ceramics, cast iron', col:'#1565c0' },
    { name:'Zirconia Alumina\n(ZrO₂)', hardness:'~1800 HV', tough:'High', friab:'Med',     temp:'~800°C', bestFor:'Stainless steel, exotic alloys, heavy grinding', col:'#1e7a36' },
    { name:'Ceramic\n(Sol-gel Al₂O₃)', hardness:'~2200 HV', tough:'V.High',friab:'Controlled',temp:'>800°C',bestFor:'Aerospace alloys, titanium, high-alloy steel', col:'#c0392b' },
    { name:'CBN\n(cubic boron nitride)',hardness:'~4500 HV', tough:'High', friab:'Low',     temp:'>1000°C',bestFor:'Hardened steel, superalloys, precision grinding', col:'#e07b00' },
    { name:'Diamond\n(synthetic)',      hardness:'~8000 HV', tough:'Low',  friab:'Med',     temp:'~400°C*',bestFor:'Ceramics, composites, carbide, stone (*reacts with steel)', col:'#546e7a' },
  ];

  const colW = W / 3;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Abrasive Grain Materials — Properties &amp; Application Guide</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        {/* Header */}
        <rect x={0} y={0} width={W} height={28} fill="#1e7a36"/>
        {['Abrasive Material', 'Key Properties', 'Best For'].map((h, i) => (
          <text key={i} x={i * colW + colW/2} y={19} textAnchor="middle" fontSize="12" fill="#fff" fontWeight="700">{h}</text>
        ))}

        {materials.map(({ name, hardness, tough, friab, temp, bestFor, col }, i) => {
          const row = Math.floor(i / 2);
          const side = i % 2;
          const baseX = side === 0 ? 0 : W / 2;
          const y = 28 + row * 108;
          const bg = row % 2 === 0 ? '#edf7f0' : '#fff';
          const halfW = W / 2;

          return (
            <g key={i}>
              {/* Name cell */}
              <rect x={baseX} y={y} width={halfW / 3} height={108} fill={bg} stroke="#b6dfc0" strokeWidth="0.8"/>
              <rect x={baseX + 6} y={y + 8} width={8} height={92} rx={2} fill={col}/>
              {name.split('\n').map((line, li) => (
                <text key={li} x={baseX + 22} y={y + 24 + li * 18} fontSize="11" fill="#145a24" fontWeight="700">{line}</text>
              ))}

              {/* Properties cell */}
              <rect x={baseX + halfW/3} y={y} width={halfW / 3} height={108} fill={bg} stroke="#b6dfc0" strokeWidth="0.8"/>
              <text x={baseX + halfW/3 + 8} y={y+20} fontSize="10" fill="#333">Hardness: {hardness}</text>
              <text x={baseX + halfW/3 + 8} y={y+36} fontSize="10" fill="#333">Toughness: {tough}</text>
              <text x={baseX + halfW/3 + 8} y={y+52} fontSize="10" fill="#333">Friability: {friab}</text>
              <text x={baseX + halfW/3 + 8} y={y+68} fontSize="10" fill="#333">Max temp: {temp}</text>

              {/* Application cell */}
              <rect x={baseX + 2*halfW/3} y={y} width={halfW / 3} height={108} fill={bg} stroke="#b6dfc0" strokeWidth="0.8"/>
              {bestFor.split(', ').map((app, ai) => (
                <text key={ai} x={baseX + 2*halfW/3 + 8} y={y + 22 + ai * 16} fontSize="9.5" fill="#546e7a">{app}</text>
              ))}
            </g>
          );
        })}
      </svg>
      <div style={S.dCaption}>Abrasive selection is the most critical process variable — wrong abrasive causes rapid loading, poor finish, and thermal damage. Aluminium oxide dominates general-purpose coated abrasives due to its balance of hardness, toughness, and cost. Ceramic (sol-gel) alumina self-sharpens by controlled micro-fracture, maintaining cutting efficiency over the full belt life. CBN and diamond are used as bonded abrasives in precision grinding rather than coated belts.</div>
    </div>
  );
}

// ── Main export ────────────────────────────────────────────────────
export default function Sanding() {
  return (
    <div style={S.wrapper}>
      <h1 style={S.h1}>Sanding — Industrial Engineering</h1>
      <p style={S.p}>
        Sanding — or abrasive machining with coated abrasives — is one of the most widely used surface-finishing and material-removal processes in manufacturing. It encompasses everything from rough stock removal on wide-belt sanders to micro-finishing of optical components with diamond abrasive film. Understanding the mechanics of abrasive grain cutting, grit selection, machine parameters, thermal effects, and process control is essential for achieving consistent surface quality, managing tool life, and preventing workpiece damage.
      </p>

      <InfoBox title="Core Concepts at a Glance" items={[
        "Coated abrasive structure: abrasive grains bonded to a flexible backing via make coat (primary) and size coat (secondary bond)",
        "Three grain interaction modes: cutting (chip formation), ploughing (displacement), rubbing (friction only) — only cutting removes material efficiently",
        "Grit number: CAMI/FEPA standard; higher number = finer grain = lower Ra but also lower MRR; grit size d (µm) ≈ 15,000 / grit number",
        "Belt speed is the most influential parameter: typical range 10–40 m/s; higher speed → lower Ra but exponentially higher interface temperature",
        "Contact pressure controls MRR: too low = rubbing/loading; too high = grain pullout, thermal damage",
        "Grain loading (swarf embedding) is the primary failure mode; anti-loading stearate coatings extend life on soft materials",
        "Successive grit progression: never skip more than one grade; each grit must remove the scratches of the previous",
        "Thermal damage threshold: ~250°C for most steels and polymers; aluminium alloys as low as 150°C",
        "Dust extraction: mandatory for fire safety, health compliance (COSHH, OSHA), and surface quality",
      ]}/>

      <h2 style={S.h2}>Coated Abrasive Construction</h2>
      <p style={S.p}>
        A coated abrasive product consists of four functional layers: a backing that provides mechanical support and flexibility, a make coat that anchors grains to the backing, the abrasive grain layer itself, and a size coat that locks grains in position and controls the active cutting height. The backing weight designation (A–E for paper, J/X for cloth) governs product flexibility and resistance to tearing under belt tension.
      </p>
      <DiagramSandpaperAnatomy/>
      <Table2 rows={[
        ["Backing — paper grades","A: lightest, most flexible — hand sanding, finishing\nC/D: medium — sheet sanders, random orbital tools\nE: heavy, rigid — belt grinding, high-tension wide-belt applications"],
        ["Backing — cloth grades","J (jeans): fine weave, very flexible — contour sanding, metal polishing\nX (drills): heavy weave, high strength — wide-belt machines, drum grinders\nY: extra-heavy — aggressive applications, maximum belt tension"],
        ["Backing — film & fibre","Polyester film: dimensionally stable, uniform thickness — precision finishing, optics\nVulcanised fibre: thick, rigid, impact-resistant — grinding discs, flap discs"],
        ["Make coat","First adhesive layer applied to backing; wets and anchors grain roots\nTypically hide glue (traditional) or synthetic resin (urea-formaldehyde, epoxy)"],
        ["Size coat","Applied over make coat + grains; locks grains, controls protrusion\nHarder than make coat — determines resistance to heat and loading"],
        ["Super size coat","Optional third coating — stearate (zinc stearate) for anti-loading on soft materials\nCCOA (calcium stearate) reduces friction and heat generation"],
        ["Grain orientation","Electrostatic coating: grains oriented point-up by electric field — more aggressive cut\nGravity coating: random orientation — smoother finish, lower MRR"],
        ["Spliced joint","Endless belt joint must match belt thickness ± 0.05 mm to avoid marking\nTypes: butt splice (strongest), lap splice, tapered splice (smoothest running)"],
      ]}/>

      <h2 style={S.h2}>Abrasive Grain Materials</h2>
      <p style={S.p}>
        The abrasive grain is the cutting tool of the sanding process. Grain hardness must exceed workpiece hardness by at least 30% to avoid rapid dulling. Equally important are toughness (resistance to gross fracture under impact) and friability (tendency to micro-fracture under load, exposing new sharp edges — the self-sharpening mechanism that maintains cutting efficiency).
      </p>
      <DiagramAbrasiveMaterials/>
      <Table2 rows={[
        ["Aluminium oxide (Al₂O₃)","~2000 HV; most common coated abrasive grain\nBrown (standard), white (friable, cooler cutting), pink (medium friability)\nBest for: ferrous metals, hardwoods, general-purpose applications"],
        ["Silicon carbide (SiC)","~2500 HV; very hard, very friable, sharper than Al₂O₃\nBlack (standard), green (purer, harder) — friability causes rapid self-renewal\nBest for: non-ferrous metals, glass, ceramics, soft metals, cast iron"],
        ["Zirconia alumina","~1800 HV; tough, cool-cutting, produced by eutectic solidification\nBlue/grey colour; resists attritious wear at high pressures\nBest for: stainless steel, exotic alloys, high-pressure belt grinding"],
        ["Ceramic alumina (sol-gel)","~2200 HV; manufactured by sol-gel sintering — polycrystalline micro-structure\nSelf-sharpens at controlled rate; maintains consistent cut rate through full belt life\nBest for: aerospace alloys, titanium, high-alloy steels, critical finish applications"],
        ["CBN (cubic boron nitride)","~4500 HV; second hardest material after diamond\nChemically inert to ferrous metals (unlike diamond); stable to >1000°C\nUsed as bonded abrasive in precision grinding; not common in coated belts"],
        ["Synthetic diamond","~8000 HV; hardest known material\nReacts with ferrous metals above ~400°C — only suitable for non-ferrous\nUsed in lapping films and superfinishing tapes; not for steel"],
        ["Grain size distribution","Monograde: tight distribution — consistent finish, used for precision work\nMultigrade (blend): wider distribution — more aggressive for stock removal\nGrade tolerance per ISO 6344 / FEPA F-standards"],
      ]}/>

      <h2 style={S.h2}>Grit Size Standards &amp; Selection</h2>
      <p style={S.p}>
        Grit number is the defining parameter for surface finish and material removal rate. Two major standards govern grit designation: CAMI (traditional US system) and FEPA/ISO (European P-grading). The two systems are equivalent at coarse grits but diverge significantly at fine grits — FEPA P600 produces approximately the same finish as CAMI 360, not CAMI 600.
      </p>
      <DiagramGritScale/>
      <Table2 rows={[
        ["CAMI system","Coated Abrasive Manufacturers Institute — traditional US classification\nGrit number = number of holes per linear inch in screening mesh\nRange: P12 (coarsest) to P1200 and beyond for coated abrasives"],
        ["FEPA / ISO P-system","Federation of European Producers of Abrasives — now the international standard\nP = prefix; P-grading specified in ISO 6344-2\nP40 ≈ CAMI 40; P220 ≈ CAMI 220; diverge above P220 (P800 ≈ CAMI 400)"],
        ["Micro-grading (µ)","JIS (Japan): #400 to #30000 — equivalent to grit sizes 35–0.5 µm\nUsed for ultra-fine polishing films and lapping tapes\nNumeric grain diameter: µ-grade number ≈ d_max in µm"],
        ["Grain diameter formula","Approximate: d_mean (µm) ≈ 15,000 / CAMI grit number\nCAMI 80 → d ≈ 190 µm;  CAMI 220 → d ≈ 68 µm;  CAMI 600 → d ≈ 25 µm\nFiner grains → smaller uncut chip thickness → lower Ra"],
        ["Grit progression rule","Never skip more than one grit grade in sequence\nRationale: each grit removes the previous grit's scratch depth efficiently\nSkipping wastes time — deeper scratches require many more passes"],
        ["Ra vs grit (empirical)","Ra (µm) ≈ k × d_grain^n   (k and n depend on material and process)\nFor wood: Ra ≈ 0.002 × d^1.2;  for steel: Ra ≈ 0.001 × d^1.1\nSurface hardness shifts the relationship — harder materials give lower Ra per grit"],
        ["Grit for specific operations","P24–P40: weld grinding, rust removal, shaping\nP60–P100: stock removal, paint stripping, coarse forming\nP120–P180: pre-finish, sealer preparation\nP220–P320: final finish coat prep, between lacquer coats\nP400+: wet sanding paint, pre-polish, micro-finish"],
      ]}/>

      <h2 style={S.h2}>Grain Cutting Mechanics</h2>
      <p style={S.p}>
        Each abrasive grain acts as a single-point cutting tool with a large negative rake angle (typically −30° to −80°). The three possible interaction modes — cutting, ploughing, and rubbing — are determined by the ratio of uncut chip thickness to grain tip radius. Maximising the cutting fraction and minimising rubbing is the key to efficient, low-temperature sanding.
      </p>
      <DiagramGrainMechanics/>
      <Table2 rows={[
        ["Uncut chip thickness (h)","h = f(grain protrusion, depth of cut, belt speed, workpiece feed speed)\nh = (2v_w / v_b) × √(d_g / a_p)   [v_w = feed, v_b = belt speed, a_p = depth of cut]"],
        ["Specific grinding energy (u)","u = F_t × v_b / (MRR)  [J/mm³]\nTypical: 10–80 J/mm³ for sanding; increases as grains dull (rubbing dominates)\nHigh u → excessive heat → thermal damage"],
        ["Grain rake angle","Typically −30° to −80° (large negative rake) — compressive stress state\nLarger negative rake → more ploughing, higher force, more heat\nSharp-edged angular grains reduce effective negative rake"],
        ["Chip formation threshold","Cutting begins when depth of penetration > critical value h_c ≈ r_tip / (1 + cot α)\nBelow h_c: ploughing → rubbing; above h_c: chip formation\nh_c ≈ 0.1–1 µm depending on material and grain sharpness"],
        ["Grain loading","Swarf adhesion in grain interstices — reduces cutting efficiency, increases heat\nSofter materials (aluminium, softwoods) load rapidly\nPrevented by: stearate supersize coat, adequate chip clearance, correct belt speed"],
        ["Grain pullout","Bond failure at high pressures — grain ejected before fully worn\nIndicates insufficient bond hardness; use harder grade belt for the application\nPremature pullout also occurs in hard-to-bond grain types (CBN)"],
        ["Attritious wear","Flat wear facets form on grain tips — reduces cutting efficiency\nIndicates: wrong grain type, too high belt speed, insufficient pressure\nFriable grains self-sharpen by micro-fracture before facets become dominant"],
      ]}/>

      <h2 style={S.h2}>Sanding Machine Types &amp; Belt Sander Anatomy</h2>
      <p style={S.p}>
        Industrial sanding machines range from simple bench-top belt grinders to multi-head wide-belt lines processing panels at 30 m/min. The type selection depends on workpiece geometry, material, required throughput, and finish specification. All share the same fundamental mechanics: an abrasive belt or disc driven at high speed contacts the workpiece under controlled pressure.
      </p>
      <DiagramBeltSander/>
      <Table2 rows={[
        ["Wide-belt sander","Belt width 300–1600 mm; single or multi-head; conveyor-fed\nUsed for panels (MDF, plywood, solid wood), composites, metal sheet\nTypical belt speed: 10–25 m/s; feed rate: 3–30 m/min"],
        ["Drum sander","Rotating drum with replaceable abrasive sleeve; table rises to set depth of cut\nIdeal for small/narrow workpieces, curved profiles, musical instruments\nBelt speed ~10–18 m/s; very even finish, no belt splice marks"],
        ["Stroke / oscillating belt","Narrow belt (25–100 mm) pressed by reciprocating shoe against elongated workpieces\nUsed for weld dressing, pipe finishing, bar stock, extrusions\nManual or CNC-controlled pressure for complex profiles"],
        ["Random orbital sander","Eccentric orbit + rotation → no linear scratch pattern; lowest visible scratch\nDisk sizes 75–150 mm; speed 4000–12000 rpm; grit P80–P400 common\nFinish quality depends on orbit diameter (3–8 mm) and paper grit"],
        ["Angle grinder / flap disc","High-speed (6000–11000 rpm); aggressive stock removal on welds and castings\nFlap disc: layered abrasive sheets with cushioned backing — improved finish vs fibre disc\nCommon grits P40–P120; zirconia or ceramic grain for longevity"],
        ["Robotic abrasive cell","6-axis arm with force-controlled compliance module + abrasive disc/belt end-effector\nForce control (10–100 N) maintains constant contact on complex curved surfaces\nUsed in aerospace (Ti, Inconel), automotive body finishing, medical implants"],
        ["Contact pressure (P)","P = F_normal / (belt width × contact length)   [N/mm²]\nTypical: 0.05–0.5 N/mm² for finishing; 0.5–2.0 N/mm² for stock removal\nPressure platen: steel (rigid, even finish) or rubber-faced (conforming, less marking)"],
        ["Belt tensioning","Proper tension prevents belt slippage on drums and extends belt life\nTypical: 1–3 bar pneumatic tension; measured as belt elongation % (usually 0.5–1.0%)\nOver-tension causes premature backing failure; under-tension causes overheating"],
      ]}/>

      <h2 style={S.h2}>Process Parameters &amp; Thermal Effects</h2>
      <p style={S.p}>
        The four primary process variables — belt speed, contact pressure, feed rate, and grit size — interact to determine the three key outputs: surface roughness Ra, material removal rate, and heat generation. Of these, thermal management is most critical: sanding generates significant heat at the grain–workpiece interface, and temperatures above ~250°C cause workpiece scorching, resin burn on the abrasive, and metallurgical damage on metal workpieces.
      </p>
      <DiagramHeatAndParameters/>
      <Table2 rows={[
        ["Belt speed (v_b)","Typical range: 10–40 m/s for coated abrasives; up to 80 m/s for bonded wheels\nHigher speed → lower uncut chip thickness → lower Ra; but T ∝ v_b^1.5–2.0\nReduce speed for heat-sensitive materials (aluminium, plastics, softwoods)"],
        ["Material removal rate","MRR = v_w × a_p × b  [mm³/min]   (v_w = feed, a_p = depth, b = belt width)\nAlternatively: MRR = (F_tangential × v_b) / u_specific\nTypical: 1–50 mm³/s per mm width for coated abrasive belt grinding"],
        ["Specific material removal rate Q'_w","Q'_w = MRR / belt width  [mm²/s]  — normalises for belt width comparison\nHigher Q'_w with ceramic grain vs standard Al₂O₃ at same conditions\nUsed to compare process efficiency between abrasive types"],
        ["Contact temperature model","T_interface ≈ C × (q'' × √(a_c / κ))   where q'' = heat flux [W/mm²]\na_c = contact half-length, κ = thermal diffusivity of workpiece\nSteel: κ = 12 mm²/s; aluminium: κ = 84 mm²/s (Al runs cooler per W)"],
        ["Thermal partition","~60–80% of grinding heat enters workpiece; remainder to abrasive and chips\nCoolant/lubricant shifts partition — water-based coolant most effective\nDry sanding: accept higher T → choose conservative belt speed"],
        ["Burn prevention","Reduce v_b below critical speed for material; increase v_w (feed)\nUse sharp, friable grain; maintain adequate contact pressure (avoid rubbing)\nDress/replace belt when specific energy rises >50% above baseline"],
        ["Coolant / lubricant","Water-soluble oil emulsion (1–5%): cooling and lubrication for metal\nNeat oil: better lubrication, poorer cooling — prevents rust on ferrous parts\nDry sanding: stearate anti-loading coating + dust extraction as thermal management"],
        ["Dwell time","Stationary workpiece under active belt creates heat spike and burn\nAlways maintain feed motion; park workpiece clear of belt before stopping\nAutomatic cycle interlocks prevent belt contact without workpiece motion"],
      ]}/>

      <h2 style={S.h2}>Surface Finish Achievable by Process</h2>
      <DiagramFinishComparison/>
      <Table2 rows={[
        ["Wood (softwood)","Ra 3.2–6.3 µm (P80) → Ra 0.8–1.6 µm (P180) → Ra 0.2–0.4 µm (P320)\nGrain direction matters: cross-grain sanding leaves visible scratches\nFinal pass always with grain; final grit P180–P220 before staining"],
        ["Wood (hardwood)","Similar progression but hardwoods tolerate higher pressure\nP220–P320 achievable as final grit for clear lacquer\nOak, ash: open grain requires grain filler before final fine-sanding"],
        ["Steel (structural)","P60–P120 for weld dressing, scale removal\nP180–P320 for paintable finish\nP400–P600 wet for pre-chrome or pre-anodise — Ra < 0.4 µm required"],
        ["Stainless steel","Direction of finish scratch critical for appearance (e.g. 320-grit satin)\nUse dedicated belts — avoid contamination from ferrous particles\nElectropolish after P400+ for corrosion-resistant mirror finish"],
        ["Aluminium alloys","Low melting point (660°C) — thermal damage risk high\nSilicon carbide or zirconia grain preferred; belt speed ≤ 20 m/s\nP120–P180 for anodising prep; Ra < 0.8 µm required for bright anodise"],
        ["Composites (CFRP)","Abrasive wear on grain accelerated by hard carbon fibres\nDiamond-coated or SiC belts; water flood cooling to manage dust and delamination\nCritical: no edge delamination — use sharp grain, light pressure"],
        ["MDF / engineered wood","Very abrasive to belts due to resin and fine particles\nHigh belt consumption — use ceramic grain for economy on wide-belt lines\nFinishing to P150–P180 before primer; P220+ under high-gloss paint"],
        ["Transition between grits","Each successive grit removes scratches from previous in 2–4 passes (typically)\nIf scratches visible after 6 passes, step back one grit — grain is loading or dull\nBacklighting inspection reveals residual coarse scratches not visible otherwise"],
      ]}/>

      <h2 style={S.h2}>Belt Life, Loading &amp; Conditioning</h2>
      <Table2 rows={[
        ["Belt life indicators","Rising cutting force (↑ specific energy); increasing Ra at constant conditions\nVisible swarf loading in grain valleys; reduced MRR\nMonitor: motor current on wide-belt lines; mass loss on workpiece per pass"],
        ["Grain loading (clogging)","Swarf adheres in grain interstices — lubricates surface, reduces cutting\nAggravated by: soft/gummy materials (aluminium, pine, filled polymers)\nPrevention: stearate supersize, adequate belt speed, correct feed rate"],
        ["Belt conditioning (dressing)","Running belt over rough dressing brick removes loaded swarf and exposes fresh grain\nUsed on wide-belt machines; extends belt life 2–3× on soft materials\nAutomatic dressing bars with pneumatic contact are common on production lines"],
        ["Oscillation","Belt oscillates laterally (±10–20 mm) to spread wear evenly across belt width\nPrevents belt edge wear and ensures uniform finish across workpiece width\nStandard on all wide-belt machines; speed typically 1 oscillation / 2–3 m of belt travel"],
        ["Belt storage","Store rolls horizontally at 15–25°C, 40–60% RH — prevent backing moisture absorption\nMoisture causes backing stretch → belt splice failure; low humidity causes brittleness\nCondition belts at workshop temperature/humidity for 24 h before use on precision work"],
        ["Safety","Belt speed labels mandatory (ISO 4871): max peripheral speed marked on belt\nGuarding: all nip points enclosed; interlock prevents access during operation\nDust explosion risk: LEV (local exhaust ventilation) mandatory for wood and aluminium dust"],
      ]}/>

      <h2 style={S.h2}>Quality Control &amp; Inspection</h2>
      <Table2 rows={[
        ["Surface roughness measurement","Contact profilometer (stylus) for Ra, Rz, Rq — ISO 4287\nCut-off wavelength λ_c = 0.8 mm for most sanded surfaces\nNon-contact: white light interferometry for delicate/soft surfaces"],
        ["Visual inspection","Backlighting at 90° to scratch direction reveals residual coarse scratches\nRaking light (low angle): shows waviness and tool marks\nBlacklight / UV: reveals contamination, adhesive residue"],
        ["Scratch depth vs grit","Approximate scratch depth ≈ 0.2 × grain diameter\nCAMI 120 grain (d ≈ 125 µm) → scratch depth ≈ 25 µm\nSubsequent grit must remove at least this depth per pass"],
        ["Flatness / straightness","Wide-belt produces very flat surfaces (platen); drum sander can introduce crown\nMeasure with precision straight-edge or CMM after final grit\nAcceptable flatness: typically ±0.1–0.5 mm depending on application"],
        ["Colour uniformity","Important in wood and composite finishing — uneven pressure leaves lighter/darker bands\nCheck with oblique lighting after first sealer coat\nBand width = pressure platen width; adjust contact roll pressure uniformity"],
        ["Burn / thermal damage","Steel: blue/straw temper colours visible on polished surface — metallurgical change\nWood: brownish discolouration; resin bleeding on MDF\nPlastics: surface softening, glossy spots, dimpling — irreversible"],
        ["Control chart (SPC)","Monitor Ra per production shift — X̄ chart detects grit degradation trends\nMRR chart (mass removed per pass) tracks belt condition\nCp/Cpk ≥ 1.33 required for surface quality in automotive supply chain"],
      ]}/>

      <InfoBox title="Key Formulae Summary" items={[
        "Grit grain diameter: d_mean (µm) ≈ 15,000 / CAMI grit number",
        "Uncut chip thickness: h ≈ (2v_w / v_b) × √(d_grain / a_p)   [v_w = feed, v_b = belt speed, a_p = depth of cut]",
        "Material removal rate: MRR = v_w × a_p × b   [mm³/min; b = belt width]",
        "Specific grinding energy: u = F_t × v_b / MRR   [J/mm³]  — increases as belt dulls",
        "Contact pressure: P = F_normal / (belt width × contact length)   [N/mm²]",
        "Surface roughness (empirical): Ra (µm) ≈ k × d_grain^n   (k ≈ 0.001–0.003; n ≈ 1.1–1.2)",
        "Belt speed recommendation: v_b = 10–25 m/s (wood/soft materials), 20–40 m/s (steel), ≤20 m/s (aluminium)",
        "Chip clearance angle: rake ≈ −30° to −80°; more negative → more ploughing and heat",
        "Temperature estimate: T ∝ (v_b^1.5 × P) / (κ^0.5 × v_w^0.5)   [κ = thermal diffusivity of workpiece]",
        "Belt tension: typically 1–3 bar pneumatic; elongation 0.5–1.0% of belt length",
      ]}/>
    </div>
  );
}